import { ApiService } from '@/axios'


export const getArtigos = (path) => {
    return ApiService.get(path)
}

export const getArtigobyid = (path) => {
    return ApiService.get(path)
}